/*eslint-disable*/
import React, { useState } from "react";
import AdminSidebar from "../Sidebar/AdminSidebar";
import TemporaryPasswordControl from './TemporaryPasswordControl';
import AdminNavbar from "../Navbars/AdminNavbar";
import { NavLink, useNavigate } from "react-router-dom";
import { AxiosResponse } from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { RiderApis } from "../../apis/RiderApis";
import { SuperAdminApis } from "../../apis/superAdminApi";
import { Oval } from "react-loader-spinner";
// @ts-ignore
import Select from 'react-select';



function RiderApplications() {
    const navigate = useNavigate();
    const [applications, setApplications] = React.useState<any>([]);
    const [stats, setStats] = React.useState<any>(null);
    const [searchText, setSearchText] = React.useState("");
    const [statusFilter, setStatusFilter] = React.useState("all");
    const [dojahFilter, setDojahFilter] = React.useState("all");
    const [regTypeFilter, setRegTypeFilter] = React.useState("all");
    const [fleetFilter, setFleetFilter] = React.useState("all");
    const [loader, setLoader] = React.useState(false);

    // Modal state
    const [selectedApp, setSelectedApp] = React.useState<any>(null);
    const [showDetailModal, setShowDetailModal] = React.useState(false);
  // Which rider/fleet account the support-access panel is open for. Null = closed.
  const [supportFor, setSupportFor] = React.useState<any>(null);
    const [showApproveModal, setShowApproveModal] = React.useState(false);
    const [showRejectModal, setShowRejectModal] = React.useState(false);
    const [showEditModal, setShowEditModal] = React.useState(false);
    const [showFineModal, setShowFineModal] = React.useState(false);
    const [actionLoader, setActionLoader] = React.useState(false);

    // Form fields
    const [metroRate, setMetroRate] = React.useState("");
    const [otherRate, setOtherRate] = React.useState("");
    const [fleetId, setFleetId] = React.useState("");
    const [branch, setBranch] = React.useState("");
    const [walletEnabled, setWalletEnabled] = React.useState(true);
    const [rejectionReason, setRejectionReason] = React.useState("");
    const [fineAmount, setFineAmount] = React.useState("");
    const [fineReason, setFineReason] = React.useState("");
    const [fleets, setFleets] = React.useState<any>([]);
    const [branches, setBranches] = React.useState<any>([]);

    const [showFullEditModal, setShowFullEditModal] = useState(false);
    const [editData, setEditData] = useState<any>({});
    const [editPassportPhoto, setEditPassportPhoto] = useState<File | null>(null);
    const [editValidIdPhoto, setEditValidIdPhoto] = useState<File | null>(null);
    const [editCacDocument, setEditCacDocument] = useState<File | null>(null);
    const [editTab, setEditTab] = useState<'personal' | 'kyc' | 'nok' | 'assignment' | 'bank'>('personal');

    // Metro cities
    const [availableCities, setAvailableCities] = React.useState<any[]>([]);
    const [citiesLoader, setCitiesLoader] = React.useState(false);
    const [selectedMetroCities, setSelectedMetroCities] = React.useState<any[]>([]);
    const [currentMetroCities, setCurrentMetroCities] = React.useState<any[]>([]);


    // ─── Metro Cities helpers ─────────────────────────────
    const loadCitiesForState = (stateName: string) => {
        if (!stateName) return;
        setCitiesLoader(true);
        SuperAdminApis.getNigerianCities(stateName)
            .then((response: AxiosResponse<any>) => {
                if (response?.data?.status) {
                    setAvailableCities(response?.data?.data || []);
                }
            })
            .catch(() => setAvailableCities([]))
            .finally(() => setCitiesLoader(false));
    };

    const loadRiderMetroCities = (profileId: number) => {
        SuperAdminApis.getRiderMetroCities(profileId)
            .then((response: AxiosResponse<any>) => {
                if (response?.data?.status) {
                    const cities = response?.data?.data?.metro_cities || [];
                    setCurrentMetroCities(cities);
                    setSelectedMetroCities(cities.map((c: any) => ({ value: c.city_name, label: c.city_name, state_name: c.state_name })));
                }
            })
            .catch(() => {
                setCurrentMetroCities([]);
                setSelectedMetroCities([]);
            });
    };

    const syncMetroCities = (profileId: number) => {
        if (!profileId) return;
        const cities = selectedMetroCities.map((c: any) => ({
            city_name: c.value || c.city_name,
            state_name: c.state_name || '',
        }));
        SuperAdminApis.syncRiderMetroCities(profileId, cities)
            .then((response: AxiosResponse<any>) => {
                if (response?.data?.status) {
                    toast.success("Metro cities updated");
                }
            })
            .catch(() => toast.error("Failed to update metro cities"));
    };

    const openFullEdit = (app: any) => {
        setSelectedApp(app);
        setEditData({
            first_name: app?.user?.first_name || '',
            last_name: app?.user?.last_name || '',
            email: app?.user?.email || '',
            phone_number: app?.user?.phone_number || '',
            gender: app?.gender || '',
            date_of_birth: app?.date_of_birth || '',
            rider_town: app?.rider_town || '',
            residential_address: app?.residential_address || '',
            state_of_residence: app?.state_of_residence || '',
            lga_of_residence: app?.lga_of_residence || '',
            registration_type: app?.registration_type || 'rider',
            company_name: app?.company_name || '',
            cac_number: app?.cac_number || '',
            nin: app?.nin || '',
            bvn: app?.bvn || '',
            valid_id_type: app?.valid_id_type || '',
            dojah_verification_status: app?.dojah_verification_status || 'pending',
            dojah_name_match: app?.dojah_name_match ?? false,
            dojah_dob_match: app?.dojah_dob_match ?? false,
            dojah_phone_match: app?.dojah_phone_match ?? false,
            nok_full_name: app?.nok_full_name || '',
            nok_phone_number: app?.nok_phone_number || '',
            nok_relationship: app?.nok_relationship || '',
            nok_address: app?.nok_address || '',
            guarantor_full_name: app?.guarantor_full_name || '',
            guarantor_phone_number: app?.guarantor_phone_number || '',
            guarantor_relationship: app?.guarantor_relationship || '',
            guarantor_address: app?.guarantor_address || '',
            metro_rate: app?.metro_rate ? String(Number(app.metro_rate)) : '',
            other_rate: app?.other_rate ? String(Number(app.other_rate)) : '',
            assigned_fleet_id: app?.assigned_fleet_id ? String(app.assigned_fleet_id) : '',
            assigned_branch: app?.assigned_branch || '',
            wallet_enabled: app?.wallet_enabled !== false,
            application_status: app?.application_status || '',
            bank_name: app?.bank_name || '',
            account_number: app?.account_number || '',
            account_name: app?.account_name || '',
        });
        setEditPassportPhoto(null);
        setEditValidIdPhoto(null);
        setEditCacDocument(null);
        setEditTab('personal');
        setSelectedMetroCities([]);
        setAvailableCities([]);
        if (app?.state_of_residence) loadCitiesForState(app.state_of_residence);
        if (app?.id) loadRiderMetroCities(app.id);
        setShowFullEditModal(true);
    };


    const handleFullEditSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        if (!selectedApp?.id) { toast.error("No application selected"); return; }
        setActionLoader(true);

        const fd = new FormData();
        fd.append('_method', 'PUT');
        Object.keys(editData).forEach(key => {
            if (editData[key] !== null && editData[key] !== undefined) {
                fd.append(key, typeof editData[key] === 'boolean' ? (editData[key] ? '1' : '0') : String(editData[key]));
            }
        });
        if (editPassportPhoto) fd.append('passport_photo', editPassportPhoto);
        if (editValidIdPhoto) fd.append('valid_id_photo', editValidIdPhoto);
        if (editCacDocument) fd.append('cac_document', editCacDocument);

        SuperAdminApis.adminFullUpdateApplication(selectedApp.id, fd)
            .then((response: AxiosResponse<any>) => {
                if (response?.data?.status) {
                    toast.success(response?.data?.message || "Updated successfully");
                    // Sync metro cities after full edit
                    if (selectedApp?.id) {
                        syncMetroCities(selectedApp.id);
                    }
                    setShowFullEditModal(false);
                    setSelectedApp(null);
                    fetchApplications("");
                    refreshStats();
                } else {
                    toast.error(response?.data?.message);
                }
            })
            .catch((error: any) => {
                const errors = error?.response?.data?.errors;
                if (errors) {
                    Object.values(errors).forEach((errArr: any) => {
                        if (Array.isArray(errArr)) errArr.forEach((e: string) => toast.error(e));
                    });
                } else {
                    toast.error(error?.response?.data?.message || "Update failed");
                }
            })
            .finally(() => setActionLoader(false));
    };

    // ─── Load stats ───────────────────────────────────────
    React.useEffect(() => {
        RiderApis.getRiderApplicationStats()
            .then((response: AxiosResponse<any>) => {
                if (response?.data?.status) {
                    setStats(response?.data?.data);
                }
            })
            .catch((error) => console.log(error));
    }, []);

    // ─── Load fleets ──────────────────────────────────────
    React.useEffect(() => {
        SuperAdminApis.getAllFleetWithoutPagination("", { search: '' })
            .then((response: AxiosResponse<any>) => {
                const data = response?.data?.data;
                setFleets(data?.data);
            })
            .catch((error) => {
                console.log("Fleet load error:", error);
                setFleets([]);
            });
    }, []);

    // ─── Load branches ────────────────────────────────────
    React.useEffect(() => {
        SuperAdminApis.getAllBranchesSimple()
            .then((response: AxiosResponse<any>) => {
                if (response?.data) {
                    setBranches(response?.data?.data);
                }
            })
            .catch((error) => {
                console.log("Branch load error:", error);
                setBranches([]);
            });
    }, []);

    // ─── Load applications ────────────────────────────────
    React.useEffect(() => {
        fetchApplications("");
    }, []);

    const fetchApplications = (page: any) => {
        setLoader(true);
        const query: any = {
            page: page || "",
            search: searchText,
            status: statusFilter,
            dojah_status: dojahFilter,
            registration_type: regTypeFilter,
            fleet_id: fleetFilter,
            per_page: 15,
        };
        RiderApis.getAllRiderApplications(query)
            .then((response: AxiosResponse<any>) => {
                if (response?.data?.status) {
                    setApplications(response?.data?.data);
                }
            })
            .catch((error) => console.log(error))
            .finally(() => setLoader(false));
    };

    const paginator = React.useCallback(
        (value: any) => {
            let page = "";
            if (value !== null) {
                page = value;
            }
            fetchApplications(page);
        },
        [searchText, statusFilter, dojahFilter, regTypeFilter, fleetFilter]
    );

    const refreshStats = () => {
        RiderApis.getRiderApplicationStats().then((r) => {
            if (r?.data?.status) setStats(r?.data?.data);
        });
    };


    const CustomMenuList = (props: any) => {
        const [search, setSearch] = React.useState('');
        const filteredChildren = React.useMemo(() => {
            if (!search) return props.children;
            if (!Array.isArray(props.children)) return props.children;
            return props.children.filter((child: any) =>
                child?.props?.data?.label?.toLowerCase()?.includes(search.toLowerCase())
            );
        }, [search, props.children]);

        return (
            <div>
                <div style={{ padding: '8px' }}>
                    <input
                        type="text"
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                        placeholder="Search branch..."
                        autoFocus
                        style={{
                            width: '100%',
                            padding: '8px 10px',
                            border: '1px solid #D1D1D1',
                            borderRadius: '6px',
                            fontSize: '13px',
                            outline: 'none',
                        }}
                        onFocus={(e) => e.target.style.borderColor = '#E04343'}
                        onBlur={(e) => e.target.style.borderColor = '#D1D1D1'}
                    />
                </div>
                <div style={{ maxHeight: '180px', overflowY: 'auto' }}>
                    {Array.isArray(filteredChildren) && filteredChildren.length > 0
                        ? filteredChildren
                        : <div style={{ padding: '8px 12px', fontSize: '13px', color: '#999' }}>No branches found</div>
                    }
                </div>
            </div>
        );
    };

    // ─── Open modals ──────────────────────────────────────
    const openDetail = (app: any) => {
        setSelectedApp(app);
        setShowDetailModal(true);
        if (app?.id) loadRiderMetroCities(app.id);
    };

    const openEdit = (app: any) => {
        setSelectedApp(app);
        setMetroRate(app?.metro_rate ? String(Number(app.metro_rate)) : "");
        setOtherRate(app?.other_rate ? String(Number(app.other_rate)) : "");
        setFleetId(app?.assigned_fleet_id ? String(app.assigned_fleet_id) : "");
        setBranch(app?.assigned_branch || "");
        setSelectedMetroCities([]);
        setAvailableCities([]);
        if (app?.state_of_residence) loadCitiesForState(app.state_of_residence);
        if (app?.id) loadRiderMetroCities(app.id);
        setShowEditModal(true);
    };

    const openApprove = (app: any) => {
        setSelectedApp(app);
        setMetroRate("");
        setOtherRate("");
        setFleetId("");
        setBranch("");
        setWalletEnabled(true);
        setSelectedMetroCities([]);
        setAvailableCities([]);
        if (app?.state_of_residence) loadCitiesForState(app.state_of_residence);
        setShowApproveModal(true);
    };

    const openReject = (app: any) => {
        setSelectedApp(app);
        setRejectionReason("");
        setShowRejectModal(true);
    };

    const openFine = (app: any) => {
        setSelectedApp(app);
        setFineAmount("");
        setFineReason("");
        setShowFineModal(true);
    };

    const closeAllModals = () => {
        setShowDetailModal(false);
        setShowApproveModal(false);
        setShowRejectModal(false);
        setShowEditModal(false);
        setShowFineModal(false);
        setSelectedApp(null);
        setMetroRate("");
        setOtherRate("");
        setFleetId("");
        setBranch("");
        setWalletEnabled(true);
        setRejectionReason("");
        setFineAmount("");
        setFineReason("");
    };

    // ─── Handle Approve ───────────────────────────────────
    const handleApprove = (e: React.FormEvent) => {
        e.preventDefault();
        const isFleet = selectedApp?.registration_type === 'fleet_agent';
        if (!isFleet && (!metroRate || !otherRate)) { toast.error("Both metro rate and other rate are required"); return; }
        if (!selectedApp?.id) { toast.error("No application selected"); return; }
        setActionLoader(true);

        const payload = isFleet ? {
            wallet_enabled: walletEnabled,
        } : {
            metro_rate: metroRate,
            other_rate: otherRate,
            fleet_id: fleetId || null,
            branch: branch || null,
            wallet_enabled: walletEnabled,
        };
        RiderApis.approveRiderApplication(selectedApp.id, payload)
            .then((response: AxiosResponse<any>) => {
                if (response?.data?.status) {
                    toast.success(response?.data?.message || "Approved successfully");
                    // Sync metro cities after approval
                    if (selectedMetroCities.length > 0 && selectedApp?.id) {
                        syncMetroCities(selectedApp.id);
                    }
                    closeAllModals();
                    fetchApplications("");
                    refreshStats();
                } else {
                    toast.error(response?.data?.message);
                }
            })
            .catch((error) => {
                const errors = error?.response?.data?.errors;
                if (errors) {
                    Object.values(errors).forEach((errArr: any) => {
                        if (Array.isArray(errArr)) errArr.forEach((e: string) => toast.error(e));
                    });
                } else {
                    toast.error(error?.response?.data?.message || "Approval failed");
                }
            })
            .finally(() => setActionLoader(false));
    };

    // ─── Handle Reject ────────────────────────────────────
    const handleReject = (e: React.FormEvent) => {
        e.preventDefault();
        if (!rejectionReason) { toast.error("Rejection reason is required"); return; }
        if (!selectedApp?.id) { toast.error("No application selected"); return; }
        setActionLoader(true);
        RiderApis.rejectRiderApplication(selectedApp.id, {
            rejection_reason: rejectionReason,
        })
            .then((response: AxiosResponse<any>) => {
                if (response?.data?.status) {
                    toast.success(response?.data?.message || "Application rejected");
                    closeAllModals();
                    fetchApplications("");
                    refreshStats();
                } else {
                    toast.error(response?.data?.message);
                }
            })
            .catch((error) => {
                toast.error(error?.response?.data?.message || "Rejection failed");
            })
            .finally(() => setActionLoader(false));
    };

    // ─── Handle Edit ──────────────────────────────────────
    const handleEdit = (e: React.FormEvent) => {
        e.preventDefault();
        if (!metroRate || !otherRate) { toast.error("Both metro rate and other rate are required"); return; }
        if (!selectedApp?.id) { toast.error("No application selected"); return; }
        setActionLoader(true);
        RiderApis.updateRiderRate(selectedApp.id, {
            metro_rate: metroRate,
            other_rate: otherRate,
            fleet_id: fleetId || null,
            branch: branch || null,
        })
            .then((response: AxiosResponse<any>) => {
                if (response?.data?.status) {
                    toast.success(response?.data?.message || "Updated successfully");
                    // Sync metro cities after edit
                    if (selectedApp?.id) {
                        syncMetroCities(selectedApp.id);
                    }
                    closeAllModals();
                    fetchApplications("");
                } else {
                    toast.error(response?.data?.message);
                }
            })
            .catch((error) => {
                const errors = error?.response?.data?.errors;
                if (errors) {
                    Object.values(errors).forEach((errArr: any) => {
                        if (Array.isArray(errArr)) errArr.forEach((e: string) => toast.error(e));
                    });
                } else {
                    toast.error(error?.response?.data?.message || "Update failed");
                }
            })
            .finally(() => setActionLoader(false));
    };

    // ─── Handle Fine ──────────────────────────────────────
    const handleFine = (e: React.FormEvent) => {
        e.preventDefault();
        if (!fineAmount || Number(fineAmount) <= 0) { toast.error("Enter a valid fine amount"); return; }
        if (!fineReason) { toast.error("Reason is required"); return; }
        if (!selectedApp?.user_id) { toast.error("No rider selected"); return; }
        setActionLoader(true);
        SuperAdminApis.applyFine(selectedApp.user_id, {
            amount: fineAmount,
            reason: fineReason,
        })
            .then((response: AxiosResponse<any>) => {

                if (response?.data?.status) {
                    toast.success(response?.data?.message || "Fine applied successfully");
                    closeAllModals();
                    fetchApplications("");
                } else {
                    toast.error(response?.data?.message);
                }
            })
            .catch((error) => {
                toast.error(error?.response?.data?.message || "Failed to apply fine");
            })
            .finally(() => setActionLoader(false));
    };

    // ─── Retry Dojah ──────────────────────────────────────
    const retryVerification = (id: number) => {
        setActionLoader(true);
        RiderApis.retryDojahVerification(id)
            .then((response: AxiosResponse<any>) => {
                if (response?.data?.status) {
                    toast.success(response?.data?.message);
                    fetchApplications("");
                    refreshStats();
                } else {
                    toast.error(response?.data?.message);
                }
            })
            .catch((error) => toast.error("Verification retry failed"))
            .finally(() => setActionLoader(false));
    };

    // ─── Toggle Flag ──────────────────────────────────────
    const toggleFlag = (id: number, isFlagged: boolean) => {
        if (!isFlagged) {
            const reason = prompt("Enter reason for flagging:");
            if (!reason) return;
            setActionLoader(true);
            RiderApis.toggleRiderFlag(id, { flag_reason: reason })
                .then((response: AxiosResponse<any>) => {
                    toast.success(response?.data?.message);
                    fetchApplications("");
                })
                .catch((error) => toast.error("Flag toggle failed"))
                .finally(() => setActionLoader(false));
        } else {
            setActionLoader(true);
            RiderApis.toggleRiderFlag(id, {})
                .then((response: AxiosResponse<any>) => {
                    toast.success(response?.data?.message);
                    fetchApplications("");
                })
                .catch((error) => toast.error("Unflag failed"))
                .finally(() => setActionLoader(false));
        }
    };

    // ─── Badge helpers ────────────────────────────────────
    const statusBadge = (status: string) => {
        switch (status) {
            case "approved": return "bg-green-100 text-green-700";
            case "rejected": return "bg-red-100 text-red-700";
            case "pending_review": return "bg-blue-100 text-blue-700";
            case "pending_verification": return "bg-yellow-100 text-yellow-700";
            default: return "bg-gray-100 text-gray-700";
        }
    };

    const dojahBadge = (status: string) => {
        switch (status) {
            case "verified": return "bg-green-100 text-green-700";
            case "failed": return "bg-red-100 text-red-700";
            case "pending": return "bg-yellow-100 text-yellow-700";
            case "not_required": return "bg-gray-100 text-gray-500";
            default: return "bg-gray-100 text-gray-700";
        }
    };

    const regTypeBadge = (type: string) => {
        switch (type) {
            case "fleet_agent": return "bg-purple-100 text-purple-700";
            case "rider": return "bg-blue-100 text-blue-700";
            default: return "bg-gray-100 text-gray-700";
        }
    };

    const getFleetName = (id: any) => {
        if (!id) return "—";
        const found = Array.isArray(fleets) ? fleets.find((f: any) => f.id == id) : null;
        return found ? (found.first_name || found.name || `Fleet #${id}`) : `Fleet #${id}`;
    };

    const formatRate = (rate: any) => {
        return Number(rate) > 0 ? `₦${Number(rate).toLocaleString()}` : "—";
    };

    return (
        <>
            <AdminSidebar title="Rider Applications" />
            <div className="relative md:ml-64 bg-[#FAFAFA]">
                <AdminNavbar title="Rider Applications" />
                <div className="lg:px-10 pb-6 px-6 bg-[#FAFAFA] min-h-screen">

                    {/* ── Stats Cards ──────────────────────────────── */}
                    {stats && (
                        <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-3 mb-6">
                            {[
                                { label: "Total", value: stats.total, color: "bg-gray-50" },
                                { label: "Pending KYC", value: stats.pending_verification, color: "bg-yellow-50" },
                                { label: "Pending Review", value: stats.pending_review, color: "bg-blue-50" },
                                { label: "Approved", value: stats.approved, color: "bg-green-50" },
                                { label: "Rejected", value: stats.rejected, color: "bg-red-50" },
                                { label: "Flagged", value: stats.flagged, color: "bg-orange-50" },
                                { label: "Dojah Failed", value: stats.dojah_failed, color: "bg-pink-50" },
                                { label: "Riders", value: stats.riders, color: "bg-blue-50" },
                                { label: "Fleet Agents", value: stats.fleet_agents, color: "bg-purple-50" },
                                { label: "Legacy Unmigrated", value: (stats.legacy_unmigrated_fleets || 0) + (stats.legacy_unmigrated_riders || 0), color: "bg-amber-50" },
                            ].map((s, i) => (
                                <div key={i} className={`${s.color} rounded-[10px] p-3 text-center`}>
                                    <p className="text-[22px] font-[700] text-[#333333]">{s.value ?? 0}</p>
                                    <p className="text-[11px] text-[#808080]">{s.label}</p>
                                </div>
                            ))}
                        </div>
                    )}

                    {/* ── Filters ──────────────────────────────────── */}
                    <div className="flex flex-wrap justify-between items-center my-5 gap-3">
                        <h3 className="text-[15px] text-[#1C1C1C] font-semibold">Rider Applications</h3>
                        <div className="flex flex-wrap gap-2 items-center">
                            <select value={statusFilter} onChange={(e) => setStatusFilter(e.target.value)} className="border border-gray-300 text-sm rounded-md p-1.5 text-gray-600">
                                <option value="all">All Status</option>
                                <option value="pending_verification">Pending KYC</option>
                                <option value="pending_review">Pending Review</option>
                                <option value="approved">Approved</option>
                                <option value="rejected">Rejected</option>
                            </select>
                            <select value={regTypeFilter} onChange={(e) => setRegTypeFilter(e.target.value)} className="border border-gray-300 text-sm rounded-md p-1.5 text-gray-600">
                                <option value="all">All Types</option>
                                <option value="rider">Rider</option>
                                <option value="fleet_agent">Fleet Agent</option>
                            </select>
                            <select value={dojahFilter} onChange={(e) => setDojahFilter(e.target.value)} className="border border-gray-300 text-sm rounded-md p-1.5 text-gray-600">
                                <option value="all">All KYC</option>
                                <option value="verified">Verified</option>
                                <option value="failed">Failed</option>
                                <option value="pending">Pending</option>
                                <option value="not_required">Not Required</option>
                            </select>
                            <select value={fleetFilter} onChange={(e) => setFleetFilter(e.target.value)} className="border border-gray-300 text-sm rounded-md p-1.5 text-gray-600">
                                <option value="all">All Fleets</option>
                                {Array.isArray(fleets) && fleets.map((f: any) => (<option key={f.id} value={f.id}>{f.first_name || f.name}</option>))}
                            </select>
                            <input type="text" onChange={(e) => setSearchText(e.target.value)} placeholder="search..." className="border border-gray-300 text-gray-500 text-sm rounded-md block pl-4 p-1.5" />
                            <button type="button" onClick={() => fetchApplications("")} className="font-normal text-white bg-[#E04343] px-3 py-1.5 rounded-md text-sm">Search</button>
                        </div>
                    </div>

                    {/* ── Table ─────────────────────────────────────── */}
                    <div className="relative overflow-x-auto">
                        {loader && (
                            <div className="flex justify-center py-10">
                                <Oval visible={true} height="40" width="40" color="#E04343" secondaryColor="#FCBF94" ariaLabel="oval-loading" />
                            </div>
                        )}
                        {!loader && (
                            <table className="w-full text-sm text-left text-gray-500 border-separate border-spacing-y-3">
                                <thead className="text-[12px] text-[#030229] bg-[#FAFAFA]">
                                    <tr>
                                        <th className="px-2 py-2">S/N</th>
                                        <th className="px-2 py-2">Name</th>
                                        <th className="px-2 py-2">Type</th>
                                        <th className="px-2 py-2">Email</th>
                                        <th className="px-2 py-2">Town</th>
                                        <th className="px-2 py-2">Fleet</th>
                                        <th className="px-2 py-2">KYC</th>
                                        <th className="px-2 py-2">Status</th>
                                        <th className="px-2 py-2">Metro Rate</th>
                                        <th className="px-2 py-2">Other Rate</th>
                                        <th className="px-2 py-2">Wallet</th>
                                        <th className="px-2 py-2">Flagged</th>
                                        <th className="px-2 py-2">Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {applications?.data?.length > 0 ? (
                                        applications?.data?.map((app: any, index: any) => (
                                            <tr key={app.id} className="bg-white">
                                                <td className="px-2 py-3 text-[12px]">{index + 1}</td>
                                                <td className="px-2 py-3 text-[12px]">{app?.user?.first_name} {app?.user?.last_name}</td>
                                                <td className="px-2 py-3">
                                                    <span className={`px-2 py-0.5 rounded-full text-[10px] font-[500] ${regTypeBadge(app?.registration_type)}`}>
                                                        {app?.registration_type === 'fleet_agent' ? 'Fleet Agent' : 'Rider'}
                                                    </span>
                                                </td>
                                                <td className="px-2 py-3 text-[12px]">{app?.user?.email}</td>
                                                <td className="px-2 py-3 text-[12px]">{app?.rider_town || "—"}</td>
                                                <td className="px-2 py-3 text-[12px]">{getFleetName(app?.assigned_fleet_id)}</td>
                                                <td className="px-2 py-3">
                                                    <span className={`px-2 py-0.5 rounded-full text-[11px] font-[500] ${dojahBadge(app?.dojah_verification_status)}`}>{app?.dojah_verification_status}</span>
                                                </td>
                                                <td className="px-2 py-3">
                                                    <span className={`px-2 py-0.5 rounded-full text-[11px] font-[500] ${statusBadge(app?.application_status)}`}>{app?.application_status?.replace(/_/g, " ")}</span>
                                                </td>
                                                <td className="px-2 py-3 text-[12px] font-[500]">{formatRate(app?.metro_rate)}</td>
                                                <td className="px-2 py-3 text-[12px] font-[500]">{formatRate(app?.other_rate)}</td>
                                                <td className="px-2 py-3">
                                                    {app?.application_status === 'approved' ? (
                                                        app?.wallet_enabled === false ? (
                                                            <span className="px-2 py-0.5 rounded-full text-[10px] font-[500] bg-gray-100 text-gray-500">Off</span>
                                                        ) : (
                                                            <span className="px-2 py-0.5 rounded-full text-[10px] font-[500] bg-green-100 text-green-700">On</span>
                                                        )
                                                    ) : (
                                                        <span className="text-[11px] text-gray-300">—</span>
                                                    )}
                                                </td>
                                                <td className="px-2 py-3">
                                                    {app?.is_flagged ? (
                                                        <span className="px-2 py-0.5 rounded-full text-[11px] font-[500] bg-red-100 text-red-700">Flagged</span>
                                                    ) : (
                                                        <span className="text-[11px] text-gray-400">No</span>
                                                    )}
                                                </td>
                                                <td className="px-2 py-3">
                                                    <div className="flex gap-1.5 flex-wrap">
                                                        <button onClick={() => openDetail(app)} className="text-[11px] bg-blue-50 text-blue-600 px-2 py-1 rounded">View</button>
                                                        <button onClick={() => setSupportFor(app)} title="Generate a temporary login password" className="text-[11px] bg-red-50 text-[#E04343] px-2 py-1 rounded">Support</button>
                                                        {app?.application_status === "pending_verification" && (
                                                            <button onClick={() => retryVerification(app.id)} className="text-[11px] bg-yellow-50 text-yellow-600 px-2 py-1 rounded">Retry KYC</button>
                                                        )}
                                                        {app?.application_status === "pending_review" && (
                                                            <>
                                                                <button onClick={() => openApprove(app)} className="text-[11px] bg-green-50 text-green-600 px-2 py-1 rounded">Approve</button>
                                                                <button onClick={() => openReject(app)} className="text-[11px] bg-red-50 text-red-600 px-2 py-1 rounded">Reject</button>
                                                            </>
                                                        )}
                                                        {app?.application_status === "approved" && app?.registration_type !== 'fleet_agent' && (
                                                            <button onClick={() => openEdit(app)} className="text-[11px] bg-purple-50 text-purple-600 px-2 py-1 rounded">Edit</button>
                                                        )}
                                                        <button onClick={() => openFullEdit(app)} className="text-[11px] bg-orange-50 text-orange-600 px-2 py-1 rounded">Full Edit</button>
                                                        {app?.application_status === "approved" && !(app?.registration_type === 'rider' && app?.assigned_fleet_id) && (
                                                            <button onClick={() => openFine(app)} className="text-[11px] bg-pink-50 text-pink-600 px-2 py-1 rounded">Fine</button>
                                                        )}
                                                    </div>
                                                </td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan={13} className="py-8 text-center text-gray-400">No applications found</td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        )}
                    </div>

                    {/* ── Pagination ───────────────────────────────── */}
                    <div className="m-4 flex justify-end mt-10">
                        {applications?.links?.map((datas: any, index: any) => (
                            <button
                                key={index}
                                onClick={() => paginator(datas?.label === "Next &raquo;" ? datas?.url?.charAt(datas?.url?.length - 1) : datas?.label === "&laquo; Previous" ? datas?.url?.charAt(datas?.url?.length - 1) : datas?.label)}
                                disabled={datas?.active}
                                className={"mx-1 py-1 px-2 " + (datas?.active === false || datas?.url === null ? "bg-gray-300 text-black" : "bg-[#E04343] text-white")}
                            >
                                {datas?.label === "&laquo; Previous" ? "< Previous" : datas?.label === "Next &raquo;" ? "Next >" : datas?.label}
                            </button>
                        ))}
                    </div>
                </div>
            </div>

            {/* ═══════════════════════════════════════════════════════
          DETAIL MODAL
          ═══════════════════════════════════════════════════════ */}
            {showDetailModal && selectedApp && (
                <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
                    <div className="bg-white rounded-[10px] max-w-2xl w-full max-h-[85vh] overflow-y-auto p-6">
                        <div className="flex justify-between items-center mb-4">
                            <h3 className="text-[16px] font-[600] text-[#333333]">Application Details</h3>
                            <button onClick={closeAllModals} className="text-gray-400 hover:text-gray-600 text-xl">&times;</button>
                        </div>

                        {/* Status + Type Banner */}
                        <div className="flex gap-2 mb-4">
                            <div className={`flex-1 p-2 rounded-[10px] text-center ${statusBadge(selectedApp?.application_status)}`}>
                                <span className="text-[13px] font-[500] capitalize">{selectedApp?.application_status?.replace(/_/g, " ")}</span>
                                {selectedApp?.rejection_reason && <p className="text-[11px] mt-1">Reason: {selectedApp.rejection_reason}</p>}
                            </div>
                            <div className={`px-4 p-2 rounded-[10px] text-center ${regTypeBadge(selectedApp?.registration_type)}`}>
                                <span className="text-[13px] font-[500]">{selectedApp?.registration_type === 'fleet_agent' ? 'Fleet Agent' : 'Rider'}</span>
                            </div>
                        </div>

                        {/* Personal Info */}
                        <h4 className="text-[13px] font-[600] text-[#333333] mb-2">Personal Information</h4>
                        <div className="grid grid-cols-2 gap-3 text-[13px] mb-4">
                            <div><span className="text-[#808080]">Name:</span> <span className="font-[500]">{selectedApp?.user?.first_name} {selectedApp?.user?.last_name}</span></div>
                            <div><span className="text-[#808080]">Email:</span> <span className="font-[500]">{selectedApp?.user?.email}</span></div>
                            <div><span className="text-[#808080]">Phone:</span> <span className="font-[500]">{selectedApp?.user?.phone_number}</span></div>
                            <div><span className="text-[#808080]">Gender:</span> <span className="font-[500] capitalize">{selectedApp?.gender}</span></div>
                            <div><span className="text-[#808080]">DOB:</span> <span className="font-[500]">{selectedApp?.date_of_birth ? new Date(selectedApp.date_of_birth).toLocaleDateString() : "—"}</span></div>
                            <div><span className="text-[#808080]">Town/City:</span> <span className="font-[500]">{selectedApp?.rider_town || "—"}</span></div>
                            <div><span className="text-[#808080]">State:</span> <span className="font-[500]">{selectedApp?.state_of_residence}</span></div>
                            <div><span className="text-[#808080]">LGA:</span> <span className="font-[500]">{selectedApp?.lga_of_residence}</span></div>
                            <div><span className="text-[#808080]">ID Type:</span> <span className="font-[500] capitalize">{selectedApp?.valid_id_type?.replace(/_/g, " ")}</span></div>
                            <div className="col-span-2"><span className="text-[#808080]">Address:</span> <span className="font-[500]">{selectedApp?.residential_address}</span></div>
                        </div>

                        {/* Fleet Agent Company Info */}
                        {selectedApp?.registration_type === 'fleet_agent' && (selectedApp?.company_name || selectedApp?.cac_number) && (
                            <div className="p-3 bg-purple-50 rounded-[10px] mb-3">
                                <h4 className="text-[13px] font-[600] text-purple-800 mb-2">Fleet Agent Company Info</h4>
                                <div className="grid grid-cols-2 gap-2 text-[12px]">
                                    {selectedApp?.company_name && <div><span className="text-purple-600">Company:</span> <span className="font-[500]">{selectedApp.company_name}</span></div>}
                                    {selectedApp?.cac_number && <div><span className="text-purple-600">CAC Number:</span> <span className="font-[500]">{selectedApp.cac_number}</span></div>}
                                </div>
                                {selectedApp?.cac_document_url && (
                                    <a href={selectedApp.cac_document_url} target="_blank" rel="noreferrer" className="text-[11px] text-purple-600 underline mt-1 inline-block">View CAC Document</a>
                                )}
                            </div>
                        )}

                        {/* Assignment Details */}
                        {selectedApp?.application_status === "approved" && (
                            <div className="p-3 bg-green-50 rounded-[10px] mb-3">
                                <div className="flex justify-between items-center mb-2">
                                    <h4 className="text-[13px] font-[600] text-green-800">
                                        {selectedApp?.registration_type === 'fleet_agent' ? 'Fleet Agent Info' : 'Assignment Details'}
                                    </h4>
                                    {selectedApp?.registration_type !== 'fleet_agent' && (
                                        <button onClick={() => { setShowDetailModal(false); openEdit(selectedApp); }} className="text-[11px] bg-purple-100 text-purple-700 px-2 py-1 rounded font-[500]">Edit</button>
                                    )}
                                    <button onClick={() => { setShowDetailModal(false); openFullEdit(selectedApp); }} className="text-[13px] bg-orange-600 text-white px-4 py-2 rounded-[10px]">Full Edit</button>
                                </div>

                                {selectedApp?.registration_type === 'fleet_agent' ? (
                                    <div className="text-[12px]">
                                        <p className="text-green-700">This is a fleet agent account. Their wallet receives earnings from riders under their fleet.</p>
                                        {selectedApp?.company_name && (
                                            <p className="mt-1"><span className="text-green-700">Company:</span> <span className="font-[600]">{selectedApp.company_name}</span></p>
                                        )}
                                    </div>
                                ) : (
                                    <>
                                        <div className="grid grid-cols-2 md:grid-cols-4 gap-3 text-[12px]">
                                            <div><span className="text-green-700">Metro Rate:</span> <span className="font-[600]">{formatRate(selectedApp?.metro_rate)}</span></div>
                                            <div><span className="text-green-700">Other Rate:</span> <span className="font-[600]">{formatRate(selectedApp?.other_rate)}</span></div>
                                            <div><span className="text-green-700">Fleet:</span> <span className="font-[600]">{getFleetName(selectedApp?.assigned_fleet_id)}</span></div>
                                            <div><span className="text-green-700">Branch:</span> <span className="font-[600]">{selectedApp?.assigned_branch || "—"}</span></div>
                                        </div>

                                        {/* Metro Cities */}
                                        <div className="mt-2 text-[12px]">
                                            <span className="text-green-700">Metro Cities:</span>{' '}
                                            <span className="font-[500]">
                                                {currentMetroCities.length > 0
                                                    ? currentMetroCities.map((c: any) => c.city_name).join(', ')
                                                    : selectedApp?.rider_town || '—'}
                                            </span>
                                            {selectedApp?.rider_town && currentMetroCities.length > 0 && !currentMetroCities.some((c: any) => c.city_name.toLowerCase() === selectedApp.rider_town.toLowerCase()) && (
                                                <span className="text-green-600"> + {selectedApp.rider_town} (primary)</span>
                                            )}
                                        </div>

                                        {selectedApp?.assigned_fleet_id && selectedApp?.registration_type === 'rider' && (
                                            <p className="text-[11px] text-green-600 mt-2">⚠ This rider is under a fleet — no personal wallet. Earnings go to fleet wallet.</p>
                                        )}
                                    </>
                                )}

                                {/* Wallet status in detail modal */}
                                <div className="mt-2 text-[12px]">
                                    <span className="text-green-700">Wallet:</span>{' '}
                                    {selectedApp?.wallet_enabled === false ? (
                                        <span className="font-[600] text-gray-500">Disabled (paid externally by Skynet)</span>
                                    ) : (
                                        <span className="font-[600] text-green-700">Enabled</span>
                                    )}
                                </div>

                                <div className="grid grid-cols-2 gap-3 text-[12px] mt-2">
                                    <div><span className="text-green-700">Reviewed By:</span> <span className="font-[500]">{selectedApp?.reviewer?.first_name ? `${selectedApp.reviewer.first_name} ${selectedApp.reviewer.last_name}` : selectedApp?.reviewed_by || "—"}</span></div>
                                    <div><span className="text-green-700">Reviewed At:</span> <span className="font-[500]">{selectedApp?.reviewed_at ? new Date(selectedApp.reviewed_at).toLocaleString() : "—"}</span></div>
                                </div>
                            </div>
                        )}

                        {/* Next of Kin */}
                        {selectedApp?.nok_full_name && (
                            <div className="p-3 bg-[#FAFAFA] rounded-[10px] mb-3">
                                <h4 className="text-[13px] font-[600] text-[#333333] mb-2">Next of Kin</h4>
                                <div className="grid grid-cols-2 gap-2 text-[12px]">
                                    <div>Name: <span className="font-[500]">{selectedApp?.nok_full_name}</span></div>
                                    <div>Phone: <span className="font-[500]">{selectedApp?.nok_phone_number}</span></div>
                                    <div>Relationship: <span className="font-[500]">{selectedApp?.nok_relationship}</span></div>
                                    <div>Address: <span className="font-[500]">{selectedApp?.nok_address}</span></div>
                                </div>
                            </div>
                        )}

                        {/* Guarantor */}
                        {selectedApp?.guarantor_full_name && (
                            <div className="p-3 bg-[#FAFAFA] rounded-[10px] mb-3">
                                <h4 className="text-[13px] font-[600] text-[#333333] mb-2">Guarantor</h4>
                                <div className="grid grid-cols-2 gap-2 text-[12px]">
                                    <div>Name: <span className="font-[500]">{selectedApp?.guarantor_full_name}</span></div>
                                    <div>Phone: <span className="font-[500]">{selectedApp?.guarantor_phone_number}</span></div>
                                    <div>Relationship: <span className="font-[500]">{selectedApp?.guarantor_relationship}</span></div>
                                    <div>Address: <span className="font-[500]">{selectedApp?.guarantor_address}</span></div>
                                </div>
                            </div>
                        )}

                        {/* Dojah Verification */}
                        <div className="p-3 bg-[#FAFAFA] rounded-[10px] mb-3">
                            <h4 className="text-[13px] font-[600] text-[#333333] mb-2">NIN Verification (Dojah)</h4>
                            <div className="grid grid-cols-2 gap-2 text-[12px]">
                                <div>Status: <span className={`px-2 py-0.5 rounded-full text-[11px] font-[500] ${dojahBadge(selectedApp?.dojah_verification_status)}`}>{selectedApp?.dojah_verification_status}</span></div>
                                <div>Verified At: <span className="font-[500]">{selectedApp?.dojah_verified_at ? new Date(selectedApp.dojah_verified_at).toLocaleString() : "—"}</span></div>
                                <div>Name Match: <span className={selectedApp?.dojah_name_match ? "text-green-600 font-[500]" : "text-red-600 font-[500]"}>{selectedApp?.dojah_name_match ? "Yes" : "No"}</span></div>
                                <div>DOB Match: <span className={selectedApp?.dojah_dob_match ? "text-green-600 font-[500]" : "text-red-600 font-[500]"}>{selectedApp?.dojah_dob_match ? "Yes" : "No"}</span></div>
                                <div>Phone Match: <span className={selectedApp?.dojah_phone_match ? "text-green-600 font-[500]" : "text-red-600 font-[500]"}>{selectedApp?.dojah_phone_match ? "Yes" : "No"}</span></div>
                            </div>
                        </div>

                        {/* Delivery Stats */}
                        <div className="p-3 bg-[#FAFAFA] rounded-[10px] mb-3">
                            <h4 className="text-[13px] font-[600] text-[#333333] mb-2">Delivery Stats</h4>
                            <div className="grid grid-cols-4 gap-2 text-[12px]">
                                <div>Total: <span className="font-[600]">{selectedApp?.total_deliveries || 0}</span></div>
                                <div>Successful: <span className="font-[600] text-green-600">{selectedApp?.successful_deliveries || 0}</span></div>
                                <div>Disputed: <span className="font-[600] text-red-600">{selectedApp?.disputed_deliveries || 0}</span></div>
                                <div>Failed: <span className="font-[600] text-orange-600">{selectedApp?.failed_deliveries || 0}</span></div>
                            </div>
                        </div>

                        {/* Bank Account */}
                        {selectedApp?.account_number && (
                            <div className="p-3 bg-[#FAFAFA] rounded-[10px] mb-3">
                                <h4 className="text-[13px] font-[600] text-[#333333] mb-2">Bank Account</h4>
                                <div className="grid grid-cols-2 gap-2 text-[12px]">
                                    <div>Bank: <span className="font-[500]">{selectedApp?.bank_name}</span></div>
                                    <div>Account: <span className="font-[500]">{selectedApp?.account_number}</span></div>
                                    <div>Name: <span className="font-[500]">{selectedApp?.account_name}</span></div>
                                    <div>Verified: <span className={selectedApp?.bank_account_verified ? "text-green-600 font-[500]" : "text-red-600 font-[500]"}>{selectedApp?.bank_account_verified ? "Yes" : "No"}</span></div>
                                </div>
                            </div>
                        )}

                        {/* Documents */}
                        <div className="flex gap-3 mb-4">
                            {selectedApp?.passport_photo_url && <a href={selectedApp.passport_photo_url} target="_blank" rel="noreferrer" className="text-[12px] text-blue-600 underline">View Passport Photo</a>}
                            {selectedApp?.valid_id_url && <a href={selectedApp.valid_id_url} target="_blank" rel="noreferrer" className="text-[12px] text-blue-600 underline">View ID Document</a>}
                        </div>

                        {/* Timestamps */}
                        <div className="text-[11px] text-[#808080] mb-4">
                            Applied: {selectedApp?.created_at ? new Date(selectedApp.created_at).toLocaleString() : "—"}
                            {selectedApp?.updated_at && ` · Updated: ${new Date(selectedApp.updated_at).toLocaleString()}`}
                        </div>

                        {/* Action Buttons */}
                        <div className="flex gap-3 justify-end flex-wrap border-t pt-4">
                            {selectedApp?.application_status === "pending_verification" && (
                                <button onClick={() => retryVerification(selectedApp.id)} className="text-[13px] bg-yellow-500 text-white px-4 py-2 rounded-[10px]">Retry Dojah</button>
                            )}
                            {selectedApp?.application_status === "pending_review" && (
                                <>
                                    <button onClick={() => { setShowDetailModal(false); openApprove(selectedApp); }} className="text-[13px] bg-green-600 text-white px-4 py-2 rounded-[10px]">Approve</button>
                                    <button onClick={() => { setShowDetailModal(false); openReject(selectedApp); }} className="text-[13px] bg-red-600 text-white px-4 py-2 rounded-[10px]">Reject</button>
                                </>
                            )}
                            {selectedApp?.application_status === "approved" && selectedApp?.registration_type !== 'fleet_agent' && (
                                <button onClick={() => { setShowDetailModal(false); openEdit(selectedApp); }} className="text-[13px] bg-purple-600 text-white px-4 py-2 rounded-[10px]">Edit Rates / Fleet / Branch</button>
                            )}
                            {selectedApp?.application_status === "approved" && !(selectedApp?.registration_type === 'rider' && selectedApp?.assigned_fleet_id) && (
                                <button onClick={() => { setShowDetailModal(false); openFine(selectedApp); }} className="text-[13px] bg-pink-600 text-white px-4 py-2 rounded-[10px]">Fine / Deduct</button>
                            )}
                            <button
                                onClick={() => toggleFlag(selectedApp.id, selectedApp.is_flagged)}
                                className={`text-[13px] px-4 py-2 rounded-[10px] ${selectedApp.is_flagged ? "bg-green-100 text-green-700" : "bg-orange-100 text-orange-700"}`}
                            >
                                {selectedApp.is_flagged ? "Unflag Rider" : "Flag Rider"}
                            </button>
                            <button onClick={closeAllModals} className="text-[13px] border border-gray-300 px-4 py-2 rounded-[10px]">Close</button>
                        </div>
                    </div>
                </div>
            )}

            {/* ═══════════════════════════════════════════════════════
          APPROVE MODAL
          ═══════════════════════════════════════════════════════ */}
            {showApproveModal && selectedApp && (
                <div className="fixed inset-0 bg-black bg-opacity-50 z-[60] flex items-center justify-center p-4">
                    <div className="bg-white rounded-[10px] max-w-md w-full p-6">
                        <h3 className="text-[16px] font-[600] text-[#333333] mb-1">Approve {selectedApp?.registration_type === 'fleet_agent' ? 'Fleet Agent' : 'Rider'}</h3>
                        <p className="text-[12px] text-[#808080] mb-1">{selectedApp?.user?.first_name} {selectedApp?.user?.last_name} — {selectedApp?.user?.email}</p>
                        {selectedApp?.rider_town && <p className="text-[11px] text-blue-600 mb-4">Town: {selectedApp.rider_town}</p>}
                        <form onSubmit={handleApprove}>

                            {/* ── Fleet Agent: simple approval ── */}
                            {selectedApp?.registration_type === 'fleet_agent' ? (
                                <div className="mb-4">
                                    <div className="bg-purple-50 rounded-[10px] p-4 mb-3">
                                        <p className="text-[13px] text-purple-800 font-[500] mb-1">Fleet Agent Approval</p>
                                        <p className="text-[12px] text-purple-700">Approving this fleet agent will:</p>
                                        <p className="text-[12px] text-purple-700 mt-1">• Activate their account</p>
                                        <p className="text-[12px] text-purple-700">• {walletEnabled ? 'Create a wallet to receive rider earnings' : 'No wallet — paid externally by Skynet'}</p>
                                        <p className="text-[12px] text-purple-700">• Allow them to create riders under their fleet</p>
                                    </div>
                                    {selectedApp?.company_name && (
                                        <div className="bg-[#FAFAFA] rounded-[10px] p-3 mb-3 text-[12px]">
                                            <p className="text-[#808080]">Company: <span className="font-[500] text-[#333333]">{selectedApp.company_name}</span></p>
                                            {selectedApp?.cac_number && <p className="text-[#808080]">CAC: <span className="font-[500] text-[#333333]">{selectedApp.cac_number}</span></p>}
                                        </div>
                                    )}
                                </div>
                            ) : (
                                /* ── Rider: requires rates ── */
                                <>
                                    <div className="grid grid-cols-2 gap-3 mb-3">
                                        <div>
                                            <label className="text-[12px] text-[#333333] font-[500] block mb-1">Metro Rate (₦) *</label>
                                            <input type="number" value={metroRate} onChange={(e) => setMetroRate(e.target.value)} required min="0" step="0.01" className="border border-[#D1D1D1] text-sm rounded-[10px] block w-full p-2.5" placeholder="Within town" />
                                            <p className="text-[10px] text-[#808080] mt-0.5">Deliveries within {selectedApp?.rider_town || 'rider town'}</p>
                                        </div>
                                        <div>
                                            <label className="text-[12px] text-[#333333] font-[500] block mb-1">Other Rate (₦) *</label>
                                            <input type="number" value={otherRate} onChange={(e) => setOtherRate(e.target.value)} required min="0" step="0.01" className="border border-[#D1D1D1] text-sm rounded-[10px] block w-full p-2.5" placeholder="Outside town" />
                                            <p className="text-[10px] text-[#808080] mt-0.5">Deliveries outside {selectedApp?.rider_town || 'rider town'}</p>
                                        </div>
                                    </div>
                                    <div className="mb-3">
                                        <label className="text-[12px] text-[#333333] font-[500] block mb-1">Assign Fleet (optional)</label>
                                        <select value={fleetId} onChange={(e) => setFleetId(e.target.value)} className="border border-[#D1D1D1] text-sm rounded-[10px] block w-full p-2.5">
                                            <option value="">— No Fleet —</option>
                                            {Array.isArray(fleets) && fleets.map((f: any) => (<option key={f.id} value={f.id}>{f.first_name || f.name}</option>))}
                                        </select>
                                        {fleetId && <p className="text-[10px] text-orange-600 mt-0.5">⚠ Rider will not get own wallet — earnings go to fleet wallet</p>}
                                    </div>
                                    <div className="mb-4">
                                        <label className="text-[12px] text-[#333333] font-[500] block mb-1">Branch (optional)</label>

                                        <Select
                                            options={branches?.map((b: any) => ({ value: b?.branch_name, label: b?.branch_name })) || []}
                                            value={branch ? { value: branch, label: branch } : null}
                                            onChange={(selected: any) => setBranch(selected ? selected.value : '')}
                                            isClearable
                                            isSearchable
                                            placeholder="Search or select branch..."
                                            classNamePrefix="select"
                                            menuPlacement="auto"
                                            maxMenuHeight={200}
                                            styles={{
                                                control: (base: any) => ({
                                                    ...base,
                                                    borderColor: '#D1D1D1',
                                                    borderRadius: '10px',
                                                    fontSize: '14px',
                                                    minHeight: '42px',
                                                }),
                                                placeholder: (base: any) => ({
                                                    ...base,
                                                    fontSize: '13px',
                                                    color: '#DADADA',
                                                }),
                                                option: (base: any) => ({
                                                    ...base,
                                                    fontSize: '13px',
                                                    padding: '8px 12px',
                                                }),
                                                menuList: (base: any) => ({
                                                    ...base,
                                                    maxHeight: '200px',
                                                }),
                                            }}
                                        />
                                    </div>

                                    {/* Metro Cities Multi-Select */}
                                    <div className="mb-4">
                                        <label className="text-[12px] text-[#333333] font-[500] block mb-1">
                                            Metro Cities {selectedApp?.state_of_residence && <span className="text-[#808080] font-normal">({selectedApp.state_of_residence})</span>}
                                        </label>
                                        <Select
                                            isMulti
                                            options={availableCities.map((c: any) => ({ value: c.city_name, label: c.city_name, state_name: c.state_name }))}
                                            value={selectedMetroCities}
                                            onChange={(selected: any) => setSelectedMetroCities(selected || [])}
                                            isLoading={citiesLoader}
                                            isSearchable
                                            placeholder={citiesLoader ? "Loading cities..." : "Select metro cities..."}
                                            noOptionsMessage={() => selectedApp?.state_of_residence ? "No cities found for this state" : "Rider has no state set"}
                                            classNamePrefix="select"
                                            menuPlacement="auto"
                                            maxMenuHeight={180}
                                            styles={{
                                                control: (base: any) => ({
                                                    ...base,
                                                    borderColor: '#D1D1D1',
                                                    borderRadius: '10px',
                                                    fontSize: '14px',
                                                    minHeight: '42px',
                                                }),
                                                placeholder: (base: any) => ({
                                                    ...base,
                                                    fontSize: '13px',
                                                    color: '#DADADA',
                                                }),
                                                option: (base: any) => ({
                                                    ...base,
                                                    fontSize: '13px',
                                                    padding: '8px 12px',
                                                }),
                                                menuList: (base: any) => ({
                                                    ...base,
                                                    maxHeight: '180px',
                                                }),
                                                multiValue: (base: any) => ({
                                                    ...base,
                                                    backgroundColor: '#FEE2E2',
                                                    borderRadius: '6px',
                                                }),
                                                multiValueLabel: (base: any) => ({
                                                    ...base,
                                                    color: '#DC2626',
                                                    fontSize: '12px',
                                                }),
                                                multiValueRemove: (base: any) => ({
                                                    ...base,
                                                    color: '#DC2626',
                                                    ':hover': { backgroundColor: '#DC2626', color: 'white' },
                                                }),
                                            }}
                                        />
                                        <p className="text-[10px] text-[#808080] mt-0.5">
                                            Deliveries to these cities use the metro rate. Primary town ({selectedApp?.rider_town || '—'}) is always included.
                                        </p>
                                    </div>
                                </>
                            )}

                            {/* ── Wallet Toggle — shown for all types ── */}
                            <div className="mb-4 flex items-center justify-between bg-gray-50 rounded-[10px] p-3">
                                <div>
                                    <p className="text-[13px] font-[600] text-[#333333]">Enable Wallet</p>
                                    <p className="text-[11px] text-[#808080]">
                                        {walletEnabled
                                            ? 'Rider will have a wallet for earnings and withdrawals.'
                                            : 'No wallet. Skynet pays this rider/agent directly.'}
                                    </p>
                                </div>
                                <button
                                    type="button"
                                    onClick={() => setWalletEnabled(!walletEnabled)}
                                    className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors ${walletEnabled ? 'bg-green-500' : 'bg-gray-300'}`}
                                >
                                    <span className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${walletEnabled ? 'translate-x-6' : 'translate-x-1'}`} />
                                </button>
                            </div>

                            {!walletEnabled && (
                                <div className="mb-4 bg-yellow-50 border border-yellow-200 rounded-[10px] p-3 text-[11px] text-yellow-700">
                                    <strong>Wallet disabled:</strong> No delivery payment records will be created for this rider at POD time. No late fines will be calculated. The rider can still create OFD, POD, and manage shipments normally. Skynet will pay them directly outside the platform.
                                </div>
                            )}

                            <div className="flex justify-end gap-3">
                                <button type="button" onClick={closeAllModals} className="border border-gray-300 text-[13px] px-4 py-2 rounded-[10px]">Cancel</button>
                                <button type="submit" disabled={actionLoader} className="bg-green-600 text-white text-[13px] px-4 py-2 rounded-[10px] flex items-center gap-2">
                                    Approve {actionLoader && <Oval visible={true} height="16" width="16" color="#fff" secondaryColor="#FCBF94" ariaLabel="oval-loading" />}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}

            {/* ═══════════════════════════════════════════════════════
          EDIT MODAL
          ═══════════════════════════════════════════════════════ */}
            {showEditModal && selectedApp && (
                <div className="fixed inset-0 bg-black bg-opacity-50 z-[60] flex items-center justify-center p-4">
                    <div className="bg-white rounded-[10px] max-w-md w-full p-6">
                        <h3 className="text-[16px] font-[600] text-[#333333] mb-1">Edit {selectedApp?.registration_type === 'fleet_agent' ? 'Fleet Agent' : 'Rider'} Details</h3>
                        <p className="text-[12px] text-[#808080] mb-1">{selectedApp?.user?.first_name} {selectedApp?.user?.last_name} — {selectedApp?.user?.email}</p>
                        {selectedApp?.rider_town && <p className="text-[11px] text-blue-600 mb-4">Town: {selectedApp.rider_town}</p>}
                        <form onSubmit={handleEdit}>
                            <div className="grid grid-cols-2 gap-3 mb-3">
                                <div>
                                    <label className="text-[12px] text-[#333333] font-[500] block mb-1">Metro Rate (₦) *</label>
                                    <input type="number" value={metroRate} onChange={(e) => setMetroRate(e.target.value)} required min="0" step="0.01" className="border border-[#D1D1D1] text-sm rounded-[10px] block w-full p-2.5" placeholder="Within town" />
                                    {selectedApp?.metro_rate && Number(selectedApp.metro_rate) > 0 && (
                                        <p className="text-[11px] text-[#808080] mt-1">Current: {formatRate(selectedApp.metro_rate)}</p>
                                    )}
                                </div>
                                <div>
                                    <label className="text-[12px] text-[#333333] font-[500] block mb-1">Other Rate (₦) *</label>
                                    <input type="number" value={otherRate} onChange={(e) => setOtherRate(e.target.value)} required min="0" step="0.01" className="border border-[#D1D1D1] text-sm rounded-[10px] block w-full p-2.5" placeholder="Outside town" />
                                    {selectedApp?.other_rate && Number(selectedApp.other_rate) > 0 && (
                                        <p className="text-[11px] text-[#808080] mt-1">Current: {formatRate(selectedApp.other_rate)}</p>
                                    )}
                                </div>
                            </div>
                            <div className="mb-3">
                                <label className="text-[12px] text-[#333333] font-[500] block mb-1">Assign Fleet</label>
                                <select value={fleetId} onChange={(e) => setFleetId(e.target.value)} className="border border-[#D1D1D1] text-sm rounded-[10px] block w-full p-2.5">
                                    <option value="">— No Fleet —</option>
                                    {Array.isArray(fleets) && fleets.map((f: any) => (<option key={f.id} value={f.id}>{f.first_name || f.name}</option>))}
                                </select>
                                {selectedApp?.assigned_fleet_id && <p className="text-[11px] text-[#808080] mt-1">Current: {getFleetName(selectedApp.assigned_fleet_id)}</p>}
                            </div>
                            <div className="mb-4">
                                <label className="text-[12px] text-[#333333] font-[500] block mb-1">Branch</label>

                                <Select
                                    options={branches?.map((b: any) => ({ value: b?.branch_name, label: b?.branch_name })) || []}
                                    value={branch ? { value: branch, label: branch } : null}
                                    onChange={(selected: any) => setBranch(selected ? selected.value : '')}
                                    isClearable
                                    isSearchable
                                    placeholder="Search or select branch..."
                                    classNamePrefix="select"
                                    menuPlacement="auto"
                                    maxMenuHeight={200}
                                    styles={{
                                        control: (base: any) => ({
                                            ...base,
                                            borderColor: '#D1D1D1',
                                            borderRadius: '10px',
                                            fontSize: '14px',
                                            minHeight: '42px',
                                        }),
                                        placeholder: (base: any) => ({
                                            ...base,
                                            fontSize: '13px',
                                            color: '#DADADA',
                                        }),
                                        option: (base: any) => ({
                                            ...base,
                                            fontSize: '13px',
                                            padding: '8px 12px',
                                        }),
                                        menuList: (base: any) => ({
                                            ...base,
                                            maxHeight: '200px',
                                        }),
                                    }}
                                />
                                {selectedApp?.assigned_branch && <p className="text-[11px] text-[#808080] mt-1">Current: {selectedApp.assigned_branch}</p>}
                            </div>

                            {/* Metro Cities Multi-Select */}
                            <div className="mb-4">
                                <label className="text-[12px] text-[#333333] font-[500] block mb-1">
                                    Metro Cities {selectedApp?.state_of_residence && <span className="text-[#808080] font-normal">({selectedApp.state_of_residence})</span>}
                                </label>
                                <Select
                                    isMulti
                                    options={availableCities.map((c: any) => ({ value: c.city_name, label: c.city_name, state_name: c.state_name }))}
                                    value={selectedMetroCities}
                                    onChange={(selected: any) => setSelectedMetroCities(selected || [])}
                                    isLoading={citiesLoader}
                                    isSearchable
                                    placeholder={citiesLoader ? "Loading cities..." : "Select metro cities..."}
                                    noOptionsMessage={() => selectedApp?.state_of_residence ? "No cities found" : "No state set"}
                                    classNamePrefix="select"
                                    menuPlacement="auto"
                                    maxMenuHeight={180}
                                    styles={{
                                        control: (base: any) => ({ ...base, borderColor: '#D1D1D1', borderRadius: '10px', fontSize: '14px', minHeight: '42px' }),
                                        placeholder: (base: any) => ({ ...base, fontSize: '13px', color: '#DADADA' }),
                                        option: (base: any) => ({ ...base, fontSize: '13px', padding: '8px 12px' }),
                                        menuList: (base: any) => ({ ...base, maxHeight: '180px' }),
                                        multiValue: (base: any) => ({ ...base, backgroundColor: '#FEE2E2', borderRadius: '6px' }),
                                        multiValueLabel: (base: any) => ({ ...base, color: '#DC2626', fontSize: '12px' }),
                                        multiValueRemove: (base: any) => ({ ...base, color: '#DC2626', ':hover': { backgroundColor: '#DC2626', color: 'white' } }),
                                    }}
                                />
                                <p className="text-[10px] text-[#808080] mt-0.5">Primary town ({selectedApp?.rider_town || '—'}) is always included.</p>
                                {currentMetroCities.length > 0 && (
                                    <p className="text-[11px] text-[#808080] mt-1">Current: {currentMetroCities.map((c: any) => c.city_name).join(', ')}</p>
                                )}
                            </div>

                            <div className="flex justify-end gap-3">
                                <button type="button" onClick={closeAllModals} className="border border-gray-300 text-[13px] px-4 py-2 rounded-[10px]">Cancel</button>
                                <button type="submit" disabled={actionLoader} className="bg-purple-600 text-white text-[13px] px-4 py-2 rounded-[10px] flex items-center gap-2">
                                    Update {actionLoader && <Oval visible={true} height="16" width="16" color="#fff" secondaryColor="#FCBF94" ariaLabel="oval-loading" />}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}

            {/* ═══════════════════════════════════════════════════════
          REJECT MODAL
          ═══════════════════════════════════════════════════════ */}
            {showRejectModal && selectedApp && (
                <div className="fixed inset-0 bg-black bg-opacity-50 z-[60] flex items-center justify-center p-4">
                    <div className="bg-white rounded-[10px] max-w-md w-full p-6">
                        <h3 className="text-[16px] font-[600] text-[#333333] mb-1">Reject Application</h3>
                        <p className="text-[12px] text-[#808080] mb-4">{selectedApp?.user?.first_name} {selectedApp?.user?.last_name} — {selectedApp?.user?.email}</p>
                        <form onSubmit={handleReject}>
                            <div className="mb-4">
                                <label className="text-[12px] text-[#333333] font-[500] block mb-1">Rejection Reason *</label>
                                <textarea value={rejectionReason} onChange={(e) => setRejectionReason(e.target.value)} required rows={4} className="border border-[#D1D1D1] text-sm rounded-[10px] block w-full p-2.5" placeholder="Explain why this application is being rejected..." />
                            </div>
                            <div className="flex justify-end gap-3">
                                <button type="button" onClick={closeAllModals} className="border border-gray-300 text-[13px] px-4 py-2 rounded-[10px]">Cancel</button>
                                <button type="submit" disabled={actionLoader} className="bg-red-600 text-white text-[13px] px-4 py-2 rounded-[10px] flex items-center gap-2">
                                    Reject {actionLoader && <Oval visible={true} height="16" width="16" color="#fff" secondaryColor="#FCBF94" ariaLabel="oval-loading" />}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}

            {/* ═══════════════════════════════════════════════════════
          FINE / DEDUCTION MODAL
          ═══════════════════════════════════════════════════════ */}
            {showFineModal && selectedApp && (
                <div className="fixed inset-0 bg-black bg-opacity-50 z-[60] flex items-center justify-center p-4">
                    <div className="bg-white rounded-[10px] max-w-md w-full p-6">
                        <h3 className="text-[16px] font-[600] text-[#333333] mb-1">Fine / Deduction</h3>
                        <p className="text-[12px] text-[#808080] mb-1">{selectedApp?.user?.first_name} {selectedApp?.user?.last_name} — {selectedApp?.user?.email}</p>
                        <p className="text-[11px] text-[#808080] mb-4">
                            {selectedApp?.registration_type === 'fleet_agent' ? 'Fleet Agent' : 'Rider'}
                            {selectedApp?.rider_town ? ` · ${selectedApp.rider_town}` : ''}
                        </p>

                        {selectedApp?.registration_type === 'rider' && selectedApp?.assigned_fleet_id && (
                            <div className="bg-orange-50 border border-orange-200 rounded-[10px] p-3 mb-4 text-[12px] text-orange-700">
                                ⚠ This rider is under a fleet and has no personal wallet. You cannot fine them directly. Fine the fleet agent instead.
                            </div>
                        )}

                        {selectedApp?.wallet_enabled === false && !(selectedApp?.registration_type === 'rider' && selectedApp?.assigned_fleet_id) && (
                            <div className="bg-gray-50 border border-gray-200 rounded-[10px] p-3 mb-4 text-[12px] text-gray-600">
                                This rider/agent has wallet disabled (paid externally by Skynet). Fines cannot be applied through the platform.
                            </div>
                        )}

                        {!(selectedApp?.registration_type === 'rider' && selectedApp?.assigned_fleet_id) && selectedApp?.wallet_enabled !== false && (
                            <form onSubmit={handleFine}>
                                <div className="mb-3">
                                    <label className="text-[12px] text-[#333333] font-[500] block mb-1">Fine Amount (₦) *</label>
                                    <input
                                        type="number"
                                        value={fineAmount}
                                        onChange={(e) => setFineAmount(e.target.value)}
                                        required
                                        min="1"
                                        step="0.01"
                                        className="border border-[#D1D1D1] text-sm rounded-[10px] block w-full p-2.5"
                                        placeholder="e.g. 500"
                                    />
                                    <p className="text-[10px] text-[#808080] mt-0.5">Deducted from their available balance; it may take the wallet into arrears</p>
                                </div>
                                <div className="mb-4">
                                    <label className="text-[12px] text-[#333333] font-[500] block mb-1">Reason *</label>
                                    <textarea
                                        value={fineReason}
                                        onChange={(e) => setFineReason(e.target.value)}
                                        required
                                        rows={3}
                                        className="border border-[#D1D1D1] text-sm rounded-[10px] block w-full p-2.5"
                                        placeholder="Explain the reason for this fine (visible to the rider)..."
                                    />
                                </div>

                                <div className="bg-pink-50 border border-pink-200 rounded-[10px] p-3 mb-4 text-[11px] text-pink-700">
                                    <strong>Warning:</strong> This deducts the fine immediately and records it against the rider. If their balance does not cover it the wallet goes into arrears — the fine is recovered from their future earnings before they are paid again. This cannot be undone automatically.
                                </div>

                                <div className="flex justify-end gap-3">
                                    <button type="button" onClick={closeAllModals} className="border border-gray-300 text-[13px] px-4 py-2 rounded-[10px]">Cancel</button>
                                    <button type="submit" disabled={actionLoader} className="bg-pink-600 text-white text-[13px] px-4 py-2 rounded-[10px] flex items-center gap-2">
                                        Apply Fine {actionLoader && <Oval visible={true} height="16" width="16" color="#fff" secondaryColor="#FCBF94" ariaLabel="oval-loading" />}
                                    </button>
                                </div>
                            </form>
                        )}

                        {((selectedApp?.registration_type === 'rider' && selectedApp?.assigned_fleet_id) || selectedApp?.wallet_enabled === false) && (
                            <div className="flex justify-end mt-4">
                                <button type="button" onClick={closeAllModals} className="border border-gray-300 text-[13px] px-4 py-2 rounded-[10px]">Close</button>
                            </div>
                        )}
                    </div>
                </div>
            )}


            {/* ═══════════════════════════════════════════════════════
  FULL EDIT MODAL
  ═══════════════════════════════════════════════════════ */}
            {showFullEditModal && selectedApp && (
                <div className="fixed inset-0 bg-black bg-opacity-50 z-[60] flex items-center justify-center p-4">
                    <div className="bg-white rounded-[10px] max-w-3xl w-full max-h-[90vh] overflow-y-auto p-6">
                        <div className="flex justify-between items-center mb-4">
                            <h3 className="text-[16px] font-[600] text-[#333333]">
                                Full Edit — {selectedApp?.user?.first_name} {selectedApp?.user?.last_name}
                            </h3>
                            <button onClick={() => { setShowFullEditModal(false); setSelectedApp(null); }} className="text-gray-400 hover:text-gray-600 text-xl">&times;</button>
                        </div>

                        {/* Tabs */}
                        <div className="flex gap-1 mb-4 border-b overflow-x-auto">
                            {[
                                { key: 'personal', label: 'Personal Info' },
                                { key: 'kyc', label: 'KYC & Documents' },
                                { key: 'nok', label: 'Next of Kin' },
                                { key: 'assignment', label: 'Assignment' },
                                { key: 'bank', label: 'Bank Account' },
                            ].map((tab: any) => (
                                <button
                                    key={tab.key}
                                    type="button"
                                    onClick={() => setEditTab(tab.key)}
                                    className={`px-3 py-2 text-[12px] font-[500] whitespace-nowrap border-b-2 transition ${editTab === tab.key ? 'border-[#E04343] text-[#E04343]' : 'border-transparent text-[#808080] hover:text-[#333]'}`}
                                >
                                    {tab.label}
                                </button>
                            ))}
                        </div>

                        <form onSubmit={handleFullEditSubmit}>
                            {/* ── Personal Info Tab ──────────────────── */}
                            {editTab === 'personal' && (
                                <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                                    <div><label className="text-[12px] text-[#333] font-[500] block mb-1">First Name *</label><input type="text" value={editData.first_name} onChange={(e) => setEditData({ ...editData, first_name: e.target.value })} className="border border-[#D1D1D1] text-sm rounded-[10px] block w-full p-2.5" /></div>
                                    <div><label className="text-[12px] text-[#333] font-[500] block mb-1">Last Name *</label><input type="text" value={editData.last_name} onChange={(e) => setEditData({ ...editData, last_name: e.target.value })} className="border border-[#D1D1D1] text-sm rounded-[10px] block w-full p-2.5" /></div>
                                    <div><label className="text-[12px] text-[#333] font-[500] block mb-1">Email *</label><input type="email" value={editData.email} onChange={(e) => setEditData({ ...editData, email: e.target.value })} className="border border-[#D1D1D1] text-sm rounded-[10px] block w-full p-2.5" /></div>
                                    <div><label className="text-[12px] text-[#333] font-[500] block mb-1">Phone *</label><input type="text" value={editData.phone_number} onChange={(e) => setEditData({ ...editData, phone_number: e.target.value })} className="border border-[#D1D1D1] text-sm rounded-[10px] block w-full p-2.5" /></div>
                                    <div><label className="text-[12px] text-[#333] font-[500] block mb-1">Gender</label><select value={editData.gender} onChange={(e) => setEditData({ ...editData, gender: e.target.value })} className="border border-[#D1D1D1] text-sm rounded-[10px] block w-full p-2.5"><option value="">--Select--</option><option value="male">Male</option><option value="female">Female</option></select></div>
                                    <div><label className="text-[12px] text-[#333] font-[500] block mb-1">Date of Birth</label><input type="date" value={editData.date_of_birth} onChange={(e) => setEditData({ ...editData, date_of_birth: e.target.value })} className="border border-[#D1D1D1] text-sm rounded-[10px] block w-full p-2.5" /></div>
                                    <div><label className="text-[12px] text-[#333] font-[500] block mb-1">Town/City</label><input type="text" value={editData.rider_town} onChange={(e) => setEditData({ ...editData, rider_town: e.target.value })} className="border border-[#D1D1D1] text-sm rounded-[10px] block w-full p-2.5" /></div>
                                    <div><label className="text-[12px] text-[#333] font-[500] block mb-1">Registration Type</label><select value={editData.registration_type} onChange={(e) => setEditData({ ...editData, registration_type: e.target.value })} className="border border-[#D1D1D1] text-sm rounded-[10px] block w-full p-2.5"><option value="rider">Rider</option><option value="fleet_agent">Fleet Agent</option></select></div>
                                    <div className="md:col-span-2"><label className="text-[12px] text-[#333] font-[500] block mb-1">Residential Address</label><input type="text" value={editData.residential_address} onChange={(e) => setEditData({ ...editData, residential_address: e.target.value })} className="border border-[#D1D1D1] text-sm rounded-[10px] block w-full p-2.5" /></div>
                                    <div><label className="text-[12px] text-[#333] font-[500] block mb-1">State of Residence</label><input type="text" value={editData.state_of_residence} onChange={(e) => setEditData({ ...editData, state_of_residence: e.target.value })} className="border border-[#D1D1D1] text-sm rounded-[10px] block w-full p-2.5" /></div>
                                    <div><label className="text-[12px] text-[#333] font-[500] block mb-1">LGA of Residence</label><input type="text" value={editData.lga_of_residence} onChange={(e) => setEditData({ ...editData, lga_of_residence: e.target.value })} className="border border-[#D1D1D1] text-sm rounded-[10px] block w-full p-2.5" /></div>
                                    {editData.registration_type === 'fleet_agent' && (
                                        <>
                                            <div><label className="text-[12px] text-[#333] font-[500] block mb-1">Company Name</label><input type="text" value={editData.company_name} onChange={(e) => setEditData({ ...editData, company_name: e.target.value })} className="border border-[#D1D1D1] text-sm rounded-[10px] block w-full p-2.5" /></div>
                                            <div><label className="text-[12px] text-[#333] font-[500] block mb-1">CAC Number</label><input type="text" value={editData.cac_number} onChange={(e) => setEditData({ ...editData, cac_number: e.target.value })} className="border border-[#D1D1D1] text-sm rounded-[10px] block w-full p-2.5" /></div>
                                        </>
                                    )}
                                    <div><label className="text-[12px] text-[#333] font-[500] block mb-1">Application Status</label><select value={editData.application_status} onChange={(e) => setEditData({ ...editData, application_status: e.target.value })} className="border border-[#D1D1D1] text-sm rounded-[10px] block w-full p-2.5"><option value="pending_verification">Pending KYC</option><option value="pending_review">Pending Review</option><option value="approved">Approved</option><option value="rejected">Rejected</option></select></div>
                                </div>
                            )}

                            {/* ── KYC & Documents Tab ───────────────── */}
                            {editTab === 'kyc' && (
                                <div className="space-y-4">
                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                                        <div><label className="text-[12px] text-[#333] font-[500] block mb-1">NIN (11 digits)</label><input type="text" maxLength={11} value={editData.nin} onChange={(e) => setEditData({ ...editData, nin: e.target.value })} className="border border-[#D1D1D1] text-sm rounded-[10px] block w-full p-2.5" /></div>
                                        <div><label className="text-[12px] text-[#333] font-[500] block mb-1">BVN</label><input type="text" maxLength={11} value={editData.bvn} onChange={(e) => setEditData({ ...editData, bvn: e.target.value })} className="border border-[#D1D1D1] text-sm rounded-[10px] block w-full p-2.5" /></div>
                                        <div><label className="text-[12px] text-[#333] font-[500] block mb-1">Valid ID Type</label><select value={editData.valid_id_type} onChange={(e) => setEditData({ ...editData, valid_id_type: e.target.value })} className="border border-[#D1D1D1] text-sm rounded-[10px] block w-full p-2.5"><option value="">--Select--</option><option value="drivers_license">Driver's License</option><option value="voters_card">Voter's Card</option><option value="intl_passport">International Passport</option><option value="national_id">National ID</option></select></div>
                                    </div>

                                    {/* NIN Verification Override */}
                                    <div className="bg-yellow-50 rounded-[10px] p-4 border border-yellow-200">
                                        <h4 className="text-[13px] font-[600] text-yellow-800 mb-3">NIN Verification (Admin Override)</h4>
                                        <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                                            <div><label className="text-[12px] text-[#333] font-[500] block mb-1">Verification Status</label><select value={editData.dojah_verification_status} onChange={(e) => setEditData({ ...editData, dojah_verification_status: e.target.value })} className="border border-[#D1D1D1] text-sm rounded-[10px] block w-full p-2.5"><option value="pending">Pending</option><option value="verified">Verified</option><option value="failed">Failed</option><option value="not_required">Not Required</option></select></div>
                                            <div className="flex items-end gap-4 pb-2">
                                                <label className="flex items-center gap-2 text-[12px]"><input type="checkbox" checked={editData.dojah_name_match} onChange={(e) => setEditData({ ...editData, dojah_name_match: e.target.checked })} className="accent-[#E04343]" /> Name Match</label>
                                                <label className="flex items-center gap-2 text-[12px]"><input type="checkbox" checked={editData.dojah_dob_match} onChange={(e) => setEditData({ ...editData, dojah_dob_match: e.target.checked })} className="accent-[#E04343]" /> DOB Match</label>
                                                <label className="flex items-center gap-2 text-[12px]"><input type="checkbox" checked={editData.dojah_phone_match} onChange={(e) => setEditData({ ...editData, dojah_phone_match: e.target.checked })} className="accent-[#E04343]" /> Phone Match</label>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Document Uploads */}
                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                                        <div>
                                            <label className="text-[12px] text-[#333] font-[500] block mb-1">Passport Photo</label>
                                            {selectedApp?.passport_photo_url && <a href={selectedApp.passport_photo_url} target="_blank" rel="noreferrer" className="text-[11px] text-blue-600 underline mb-1 block">View current</a>}
                                            <input type="file" accept=".jpg,.jpeg,.png" onChange={(e) => setEditPassportPhoto(e.target.files?.[0] || null)} className="border border-[#D1D1D1] text-sm rounded-[10px] block w-full p-2" />
                                            {editPassportPhoto && <p className="text-[10px] text-green-600 mt-1">✓ {editPassportPhoto.name}</p>}
                                        </div>
                                        <div>
                                            <label className="text-[12px] text-[#333] font-[500] block mb-1">Valid ID Photo</label>
                                            {selectedApp?.valid_id_url && <a href={selectedApp.valid_id_url} target="_blank" rel="noreferrer" className="text-[11px] text-blue-600 underline mb-1 block">View current</a>}
                                            <input type="file" accept=".jpg,.jpeg,.png,.pdf" onChange={(e) => setEditValidIdPhoto(e.target.files?.[0] || null)} className="border border-[#D1D1D1] text-sm rounded-[10px] block w-full p-2" />
                                            {editValidIdPhoto && <p className="text-[10px] text-green-600 mt-1">✓ {editValidIdPhoto.name}</p>}
                                        </div>
                                        {editData.registration_type === 'fleet_agent' && (
                                            <div className="md:col-span-2">
                                                <label className="text-[12px] text-[#333] font-[500] block mb-1">CAC Document</label>
                                                {selectedApp?.cac_document_url && <a href={selectedApp.cac_document_url} target="_blank" rel="noreferrer" className="text-[11px] text-blue-600 underline mb-1 block">View current</a>}
                                                <input type="file" accept=".jpg,.jpeg,.png,.pdf" onChange={(e) => setEditCacDocument(e.target.files?.[0] || null)} className="border border-[#D1D1D1] text-sm rounded-[10px] block w-full p-2" />
                                                {editCacDocument && <p className="text-[10px] text-green-600 mt-1">✓ {editCacDocument.name}</p>}
                                            </div>
                                        )}
                                    </div>
                                </div>
                            )}

                            {/* ── Next of Kin Tab ───────────────────── */}
                            {editTab === 'nok' && (
                                <div className="space-y-4">
                                    <h4 className="text-[13px] font-[600] text-[#333]">Next of Kin</h4>
                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                                        <div><label className="text-[12px] text-[#333] font-[500] block mb-1">Full Name</label><input type="text" value={editData.nok_full_name} onChange={(e) => setEditData({ ...editData, nok_full_name: e.target.value })} className="border border-[#D1D1D1] text-sm rounded-[10px] block w-full p-2.5" /></div>
                                        <div><label className="text-[12px] text-[#333] font-[500] block mb-1">Phone</label><input type="text" value={editData.nok_phone_number} onChange={(e) => setEditData({ ...editData, nok_phone_number: e.target.value })} className="border border-[#D1D1D1] text-sm rounded-[10px] block w-full p-2.5" /></div>
                                        <div><label className="text-[12px] text-[#333] font-[500] block mb-1">Relationship</label><input type="text" value={editData.nok_relationship} onChange={(e) => setEditData({ ...editData, nok_relationship: e.target.value })} className="border border-[#D1D1D1] text-sm rounded-[10px] block w-full p-2.5" /></div>
                                        <div><label className="text-[12px] text-[#333] font-[500] block mb-1">Address</label><input type="text" value={editData.nok_address} onChange={(e) => setEditData({ ...editData, nok_address: e.target.value })} className="border border-[#D1D1D1] text-sm rounded-[10px] block w-full p-2.5" /></div>
                                    </div>
                                    <h4 className="text-[13px] font-[600] text-[#333] mt-4">Guarantor</h4>
                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                                        <div><label className="text-[12px] text-[#333] font-[500] block mb-1">Full Name</label><input type="text" value={editData.guarantor_full_name} onChange={(e) => setEditData({ ...editData, guarantor_full_name: e.target.value })} className="border border-[#D1D1D1] text-sm rounded-[10px] block w-full p-2.5" /></div>
                                        <div><label className="text-[12px] text-[#333] font-[500] block mb-1">Phone</label><input type="text" value={editData.guarantor_phone_number} onChange={(e) => setEditData({ ...editData, guarantor_phone_number: e.target.value })} className="border border-[#D1D1D1] text-sm rounded-[10px] block w-full p-2.5" /></div>
                                        <div><label className="text-[12px] text-[#333] font-[500] block mb-1">Relationship</label><input type="text" value={editData.guarantor_relationship} onChange={(e) => setEditData({ ...editData, guarantor_relationship: e.target.value })} className="border border-[#D1D1D1] text-sm rounded-[10px] block w-full p-2.5" /></div>
                                        <div><label className="text-[12px] text-[#333] font-[500] block mb-1">Address</label><input type="text" value={editData.guarantor_address} onChange={(e) => setEditData({ ...editData, guarantor_address: e.target.value })} className="border border-[#D1D1D1] text-sm rounded-[10px] block w-full p-2.5" /></div>
                                    </div>
                                </div>
                            )}

                            {/* ── Assignment Tab ────────────────────── */}
                            {editTab === 'assignment' && (
                                <div className="space-y-4">
                                    {editData.registration_type !== 'fleet_agent' && (
                                        <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                                            <div><label className="text-[12px] text-[#333] font-[500] block mb-1">Metro Rate (₦)</label><input type="number" step="0.01" value={editData.metro_rate} onChange={(e) => setEditData({ ...editData, metro_rate: e.target.value })} className="border border-[#D1D1D1] text-sm rounded-[10px] block w-full p-2.5" /></div>
                                            <div><label className="text-[12px] text-[#333] font-[500] block mb-1">Other Rate (₦)</label><input type="number" step="0.01" value={editData.other_rate} onChange={(e) => setEditData({ ...editData, other_rate: e.target.value })} className="border border-[#D1D1D1] text-sm rounded-[10px] block w-full p-2.5" /></div>
                                            <div>
                                                <label className="text-[12px] text-[#333] font-[500] block mb-1">Assign Fleet</label>
                                                <select value={editData.assigned_fleet_id} onChange={(e) => setEditData({ ...editData, assigned_fleet_id: e.target.value })} className="border border-[#D1D1D1] text-sm rounded-[10px] block w-full p-2.5">
                                                    <option value="">— No Fleet —</option>
                                                    {Array.isArray(fleets) && fleets.map((f: any) => (<option key={f.id} value={f.id}>{f.first_name || f.name}</option>))}
                                                </select>
                                            </div>
                                            <div>
                                                <label className="text-[12px] text-[#333] font-[500] block mb-1">Branch</label>
                                                <select value={editData.assigned_branch} onChange={(e) => setEditData({ ...editData, assigned_branch: e.target.value })} className="border border-[#D1D1D1] text-sm rounded-[10px] block w-full p-2.5">
                                                    <option value="">--Select Branch--</option>
                                                    {branches?.map((b: any, i: any) => (<option key={i} value={b?.branch_name}>{b?.branch_name}</option>))}
                                                </select>
                                            </div>



                                            <div>
                                                <label className="text-[12px] text-[#333] font-[500] block mb-1">
                                                    Metro Cities {selectedApp?.state_of_residence && <span className="text-[#808080] font-normal">({selectedApp.state_of_residence})</span>}
                                                </label>
                                                <Select
                                                    isMulti
                                                    options={availableCities.map((c: any) => ({ value: c.city_name, label: c.city_name, state_name: c.state_name }))}
                                                    value={selectedMetroCities}
                                                    onChange={(selected: any) => setSelectedMetroCities(selected || [])}
                                                    isLoading={citiesLoader}
                                                    isSearchable
                                                    placeholder={citiesLoader ? "Loading cities..." : "Select metro cities..."}
                                                    noOptionsMessage={() => selectedApp?.state_of_residence ? "No cities found" : "No state set"}
                                                    classNamePrefix="select"
                                                    menuPlacement="auto"
                                                    maxMenuHeight={180}
                                                    styles={{
                                                        control: (base: any) => ({ ...base, borderColor: '#D1D1D1', borderRadius: '10px', fontSize: '14px', minHeight: '42px' }),
                                                        placeholder: (base: any) => ({ ...base, fontSize: '13px', color: '#DADADA' }),
                                                        option: (base: any) => ({ ...base, fontSize: '13px', padding: '8px 12px' }),
                                                        menuList: (base: any) => ({ ...base, maxHeight: '180px' }),
                                                        multiValue: (base: any) => ({ ...base, backgroundColor: '#FEE2E2', borderRadius: '6px' }),
                                                        multiValueLabel: (base: any) => ({ ...base, color: '#DC2626', fontSize: '12px' }),
                                                        multiValueRemove: (base: any) => ({ ...base, color: '#DC2626', ':hover': { backgroundColor: '#DC2626', color: 'white' } }),
                                                    }}
                                                />
                                                <p className="text-[10px] text-[#808080] mt-0.5">Primary town ({selectedApp?.rider_town || '—'}) is always included.</p>
                                            </div>
                                        </div>
                                    )}
                                    <div className="flex items-center justify-between bg-gray-50 rounded-[10px] p-3">
                                        <div>
                                            <p className="text-[13px] font-[600] text-[#333]">Wallet Enabled</p>
                                            <p className="text-[11px] text-[#808080]">{editData.wallet_enabled ? 'Wallet active for earnings' : 'No wallet — paid externally'}</p>
                                        </div>
                                        <button type="button" onClick={() => setEditData({ ...editData, wallet_enabled: !editData.wallet_enabled })} className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors ${editData.wallet_enabled ? 'bg-green-500' : 'bg-gray-300'}`}>
                                            <span className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${editData.wallet_enabled ? 'translate-x-6' : 'translate-x-1'}`} />
                                        </button>
                                    </div>
                                </div>
                            )}

                            {/* ── Bank Account Tab ──────────────────── */}
                            {editTab === 'bank' && (
                                <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                                    <div><label className="text-[12px] text-[#333] font-[500] block mb-1">Bank Name</label><input type="text" value={editData.bank_name} onChange={(e) => setEditData({ ...editData, bank_name: e.target.value })} className="border border-[#D1D1D1] text-sm rounded-[10px] block w-full p-2.5" /></div>
                                    <div><label className="text-[12px] text-[#333] font-[500] block mb-1">Account Number</label><input type="text" value={editData.account_number} onChange={(e) => setEditData({ ...editData, account_number: e.target.value })} className="border border-[#D1D1D1] text-sm rounded-[10px] block w-full p-2.5" /></div>
                                    <div className="md:col-span-2"><label className="text-[12px] text-[#333] font-[500] block mb-1">Account Name</label><input type="text" value={editData.account_name} onChange={(e) => setEditData({ ...editData, account_name: e.target.value })} className="border border-[#D1D1D1] text-sm rounded-[10px] block w-full p-2.5" /></div>
                                    <div className="md:col-span-2 bg-yellow-50 border border-yellow-200 rounded-[10px] p-3 text-[11px] text-yellow-700">
                                        <strong>Note:</strong> Changing bank details here does NOT re-verify with Paystack. The rider should re-add their bank via the app for proper verification.
                                    </div>
                                </div>
                            )}

                            {/* Submit */}
                            <div className="flex justify-end gap-3 mt-6 pt-4 border-t">
                                <button type="button" onClick={() => { setShowFullEditModal(false); setSelectedApp(null); }} className="border border-gray-300 text-[13px] px-4 py-2 rounded-[10px]">Cancel</button>
                                <button type="submit" disabled={actionLoader} className="bg-[#E04343] text-white text-[13px] px-6 py-2 rounded-[10px] flex items-center gap-2">
                                    Save All Changes {actionLoader && <Oval visible={true} height="16" width="16" color="#fff" secondaryColor="#FCBF94" ariaLabel="oval-loading" />}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}

            {/* Support access. Riders and fleet agents are ordinary user accounts, so
                the same temporary-password flow works for them unchanged. */}
            {supportFor && (
                <div className="fixed inset-0 bg-black/50 flex items-start justify-center p-4 z-50 overflow-y-auto"
                    onClick={() => setSupportFor(null)}>
                    <div className="w-full max-w-2xl my-10" onClick={(e) => e.stopPropagation()}>
                        <div className="bg-white rounded-[10px] p-4 flex items-start justify-between">
                            <div>
                                <h3 className="text-[16px] font-semibold">
                                    {supportFor?.user?.first_name} {supportFor?.user?.last_name}
                                </h3>
                                <p className="text-sm text-gray-500">{supportFor?.user?.email}</p>
                            </div>
                            <button onClick={() => setSupportFor(null)}
                                className="text-gray-400 hover:text-gray-700 text-xl leading-none">&times;</button>
                        </div>

                        <TemporaryPasswordControl
                            userId={supportFor?.user?.id}
                            email={supportFor?.user?.email}
                            name={`${supportFor?.user?.first_name ?? ''} ${supportFor?.user?.last_name ?? ''}`.trim()}
                        />
                    </div>
                </div>
            )}

            <ToastContainer position="top-right" autoClose={2000} hideProgressBar={true} newestOnTop={false} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
        </>
    );
}

export default RiderApplications;